<template>
	<div>
		<div v-if="copyrightType == 1" class="copyright">
			Copyright &copy; 2018-2020 zugehao.com All Right Reserved
			<br />
			杭州创哈网络科技有限公司(www.zugehao.com)版权所有
			<br />
			浙ICP备 19004405号-2
			<br />
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：武汉诸相网络科技有限公司
			<br />
			版本：2.8.0
			<br />
		</div>
		<div v-if="copyrightType == 2" class="copyright">
			Copyright &copy; 2017-2020 All Right Reserved
			<br />
			杭州虚贝科技有限公司 版权所有
			<br />
			浙ICP备2022032879号
			<br />
			浙公网安备 33011002015387号
			<br />
			客服电话：027-65528846
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：杭州虚贝科技有限公司
			<br />
			版本：2.8.0
			<br />
		</div>
		<div v-if="copyrightType == 3" class="copyright">
			Copyright &copy; 2017-2022 ugpaly.com All Right Reserved
			<br />
			武汉竹柳科技有限公司 (ugpaly.com) 版权所有
			<br />
			鄂ICP备 鄂ICP备2022004861号-1
			<br />
			浙公网安备 33010302003346号
			<br />
			客服电话：027-65528846
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：武汉竹柳科技有限公司
			<br />
			版本：3.3.1
			<br />
			<p class="aboutUs">
				<span @click="goUrl(3)">公司简介</span>
				<span @click="goUrl(4)">联系我们</span>
			</p>
		</div>
		<div v-if="copyrightType == 4" class="copyright">
			Copyright &copy; 2018-2020 zuhw.njweisid.cn All Right Reserved
			<br />
			南京唯思登教育科技有限公司(zuhw.njweisid.cn)版权所有
			<br />
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			版本：2.8.0
			<br />
		</div>
		<div v-if="copyrightType == 5" class="copyright">
			Copyright &copy; 2017-2022 ugpaly.com All Right Reserved
			<br />
			武汉竹柳科技有限公司 (ugpaly.com) 版权所有
			<br />
			鄂ICP备2022004861号-1
			<br />
			客服电话：027-65528846
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：武汉竹柳科技有限公司
			<br />
			版本：2.8.0
			<br />
		</div>
		<div v-if="copyrightType == 6" class="copyright">
			Copyright &copy; 2017-2022 m.xubei.cc All Right Reserved
			<br />
			武汉屿回科技有限公司 (m.xubei.cc) 版权所有
			<br />
			鄂ICP备2023007937号-2
			<br />
			客服电话：027-65528846
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：武汉屿回科技有限公司
			<br />
			版本：2.8.0
			<br />
		</div>

		<div v-if="copyrightType == 7" class="copyright">
			Copyright &copy; 2017-2022 zhw.hjxgd.top All Right Reserved
			<br />
			湖北有票科技有限公司 (zhw.hjxgd.top) 版权所有
			<br />
			客服电话：027-65528846
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：湖北有票科技有限公司
			<br />
			版本：2.8.0
			<br />
		</div>

		<div v-if="copyrightType == 8" class="copyright">我公司平台游戏账号均实名认证</div>

		<div v-if="copyrightType == 9" class="copyright">
			Copyright &copy; 2017-2022 zhw.yunijy.com All Right Reserved
			<br />
			淳安县术谅网络科技工作室 (zhw.yunijy.com) 版权所有
			<br />
			客服电话：027-65528846
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：淳安县术谅网络科技工作室
			<br />
			版本：2.8.0
			<br />
		</div>

		<div v-if="copyrightType == 10" class="copyright">
			Copyright &copy; 2017-2022 zhw.zszlxx.cn All Right Reserved
			<br />
			济宁璐盛教育咨询有限公司 (zhw.zszlxx.cn) 版权所有
			<br />
			客服电话：027-65528846
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：济宁璐盛教育咨询有限公司
			<br />
			版本：2.8.0
			<br />
		</div>
		<div v-if="copyrightType == 11" class="copyright">
			Copyright &copy; 2017-2025 m.rfspeed.com All Right Reserved
			<br />
			杭州虚贝科技有限公司 (rfspeed.com) 版权所有
			<br />
			浙ICP备2022032879号-1
			<br />
			公司地址：浙江省杭州市拱墅区祥园路108号4幢11层1105室
			<br />
			客服电话：0571-88054638
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：杭州虚贝科技有限公司
			<br />
			版本：2.8.0
			<br />
		</div>
		<div v-if="copyrightType == 12" class="copyright">
			Copyright &copy; 2017-2025 xb.hzmxwl.com All Right Reserved
			<br />
			淳安莫协网络科技工作室 (xb.hzmxwl.com) 版权所有
			<br />
			浙ICP备2023006567号-1
			<br />
			公司地址：淳安莫协网络科技工作室
			<br />
			客服电话：0571-88054638
			<div class="hrefBox">
				<span @click="goUrl(1)">《用户协议》</span>
				<span @click="goUrl(2)">《隐私协议》</span>
			</div>
			开发者名称：淳安莫协网络科技工作室
			<br />
			版本：2.8.0
			<br />
		</div>
		<div v-if="copyrightType == 13" class="copyright">
			网站备案号：鄂ICP备2023026848号
			<br />
			版权所有：武汉鹏城信息科技有限公司
			<br />
		</div>
		<div v-if="copyrightType == 14" class="copyright">
			网站备案号：鲁ICP备2024069120号-1
			<br />
			版权所有：智云端大数据（青岛）有限公司
			<br />
		</div>
		<div v-if="copyrightType == 15" class="copyright">
			网站备案号：鲁ICP备2024105597号-2
			<br />
			版权所有：青岛易聚客文化传媒有限公司
			<br />
		</div>
		<div v-if="copyrightType == 16" class="copyright">
			网站备案号：苏ICP备2024062081号
			<br />
			版权所有：南京黎森宝网络科技有限公司
			<br />
		</div>
		<div v-if="copyrightType == 17" class="copyright">
			网站备案号：蜀ICP备2024114778号
			<br />
			版权所有：成都新风起易网络科技有限公司
			<br />
		</div>
		<div v-if="copyrightType == 18" class="copyright">
			网站备案号：浙ICP备2024126071号
			<br />
			版权所有：杭州素闵网络科技有限公司绵阳第三分公司
		</div>

		<div v-if="copyrightType == 19" class="copyright">
			网站备案号：浙ICP备2025181213号-1
			<br />
			版权所有：义乌市芷郁网络科技有限公司
			<br />
		</div>

        <div v-if="copyrightType == 20" class="copyright">
			网站备案号：苏ICP备2025164743号-1
			<br />
			版权所有：南京博览群书网络科技有限公司
			<br />
		</div>

		<div v-if="copyrightType == 21" class="copyright">
			网站备案号：苏ICP备2025199334号-1
			<br />
			版权所有：南京砚莫雪科技有限公司徐州分公司
			<br />
		</div>
	</div>
</template>

<script>
export default {
	name: 'page-footer',
	data() {
		return {};
	},
	computed: {
		copyrightType() {
			let href = window.location.href;
			console.log('page-footer', href);
			
			if (href.includes('zugehao')) {
				return 1;
			} else if (href.includes('hezuge')) {
				return 3;
			} else if (href.includes('zuhw.njweisid.cn')) {
				return 4;
			} else if (href.includes('ugpaly')) {
				return 5;
			} else if (href.includes('m.xubei.cc')) {
				return 6;
			} else if (href.includes('zhw.hjxgd.top')) {
				return 7;
			} else if (href.includes('zhw.dreamgardenw.cn')) {
				return 8;
			} else if (href.includes('zhw.hzcasl.com')) {
				return 9;
			} else if (href.includes('zhw.zszlxx.cn')) {
				return 10;
			} else if (href.includes('m.rfspeed.com')) {
				return 11;
			} else if (href.includes('xb.hzmxwl.com')) {
				return 12;
			} else if (href.includes('mxubei.pengchengxinxi.cn')) {
				return 13;
			} else if (href.includes('mxubei.aizyd.cn')) {
				return 14;
			} else if (href.includes('mxubei.yijukewenhua.cn')) {
				return 15;
			} else if (href.includes('mxubei.njlesba.cn')) {
				return 16;
			} else if (href.includes('mxubei.cdxfqa.top')) {
				return 17;
			} else if (href.includes('mxubei.hhzsmwlkj.cn')) {
				return 18;
			} else if (href.includes('mxubei.ziywl.cn')) {
				return 19;
			} else if (href.includes('mxubei.njblqs.com')) {
				return 20;
			} else if (href.includes('mxubei.ohwclp.cn')) {
				return 21;
			} else {
				return 2;
			}
		}
	},
	methods: {
		goUrl(type) {
			if (type == 1) {
				this.$router.push({
					path: 'servicesDetail'
				});
			} else if (type == 2) {
				this.$router.push({
					path: 'privacys'
				});
			} else if (type == 3) {
				this.$router.push({
					path: 'companyProfile'
				});
			} else if (type == 4) {
				this.$router.push({
					path: 'contactUs'
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../style/common';

.copyright {
	padding: 0.14rem 0 0.8rem;
	text-align: center;
	color: #bbb;
	font-size: 0.24rem;
	//   margin-bottom: 60px;

	div {
		margin-top: 0.04rem;

		span {
			color: #bbb;
		}
	}

	.aboutUs {
		font-size: 0.2rem;
		color: #3eaffd;
		line-height: 0.2rem;
		margin-top: 0.24rem;

		> span {
			text-decoration: underline;

			&:first-of-type {
				margin-right: 0.6rem;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/page-footer.vue